import { AxiosResponse } from "axios";
import request from "./base.service";

function guilds(params: any): Promise<AxiosResponse<any>> {
  return request.build().get(`/api/v1/guilds/visit-histories`, params)
}

function singleGuild(qrCode: any): Promise<AxiosResponse<any>> {
  return request.build().get(`/api/v1/guilds/health/status/qr-code/${qrCode}`)
}

function questions(params: any): Promise<AxiosResponse<any>> {
  return request.build().get(`/api/v1/support/questions`, params)
}

function commands(params: any): Promise<AxiosResponse<any>> {
  return request.build().get(`/api/v1/guilds/categories/citizen/commands`, params)
}

function postQAForm(params: any): Promise<AxiosResponse<any>> {
  return request.withHeaders({ 'Content-Type': 'application/json;utf-8' }).build().post('/api/v1/support/feedback-logs', params)
}

// eslint-disable-next-line
export default {
  guilds,
  singleGuild,
  questions,
  commands,
  postQAForm
};
